import { render, staticRenderFns } from "./EditAmountPopup.vue?vue&type=template&id=674fde52&scoped=true"
import script from "./EditAmountPopup.vue?vue&type=script&lang=js"
export * from "./EditAmountPopup.vue?vue&type=script&lang=js"
import style0 from "./EditAmountPopup.vue?vue&type=style&index=0&id=674fde52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674fde52",
  null
  
)

export default component.exports